module.exports = __webpack_public_path__ + "img/we4.209eaa27.svg";